var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18611",
    "data-name": "Rectangle 18611",
    width: 98.315,
    height: 97.622,
    fill: "#005cbe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23591",
    "data-name": "Group 23591",
    transform: "translate(-66 -1610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23562",
    "data-name": "Group 23562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 -51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49984",
    "data-name": "Path 49984",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 1897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23560",
    "data-name": "Group 23560",
    transform: "translate(121 1666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23558",
    "data-name": "Group 23558",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49974",
    "data-name": "Path 49974",
    d: "M12.789,95.576V90.666c-1.709,0-3.362.056-5.009-.02a11.663,11.663,0,0,1-3.128-.484,6.759,6.759,0,0,1-4.607-6.28c-.051-7.157-.074-14.314.007-21.47a7.027,7.027,0,0,1,7.231-6.777c2.258-.036,4.518-.007,6.911-.007V54.5q0-8.988,0-17.975c0-2.9,1.208-4.1,4.128-4.119.293,0,.588,0,.95,0,.024-.367.06-.658.062-.947,0-4.061-.013-8.123.017-12.183a1.3,1.3,0,0,0-.773-1.319,9.615,9.615,0,1,1,9.466-.039,1.434,1.434,0,0,0-.839,1.479c.035,3.961.016,7.923.016,11.884V32.4c.563,0,1.048-.005,1.532,0a3.405,3.405,0,0,1,3.614,3.641q.018,8.638,0,17.276v2.308h1.338q28.466,0,56.93-.005c2.931,0,5.322,1.048,6.7,3.684a8.509,8.509,0,0,1,.915,3.712c.087,6.757.051,13.515.038,20.271a7.091,7.091,0,0,1-7.264,7.37c-1.794.033-3.589.005-5.475.005v4.911h7.019c.6,0,1.2-.024,1.8.027s1.09.419.932,1.033c-.1.368-.572.691-.948.916-.224.133-.585.038-.884.038q-24.272,0-48.542,0c-.772,0-1.717.213-1.866-.956-.1-.746.5-1.053,1.887-1.053H76.1c-1.1-1.678-2.04-3.189-3.072-4.639-.163-.23-.714-.26-1.085-.26q-11.887-.022-23.771-.011c-7.259,0-14.517.011-21.774-.016a1.536,1.536,0,0,0-1.523.825c-.8,1.329-1.674,2.608-2.646,4.1h1.263q5.644,0,11.287,0c.33,0,.745-.071.971.094a1.644,1.644,0,0,1,.714,1.017c.009.28-.47.619-.792.848-.159.114-.451.051-.684.051H6.719c-.134,0-.267,0-.4,0-.646-.005-1.137-.241-1.155-.955-.017-.769.5-1.033,1.18-1.048.733-.017,1.465-.007,2.2-.007h4.245M49.209,57.643q-20.774,0-41.55,0c-3.57,0-5.635,2.072-5.637,5.643q-.006,9.836,0,19.672c0,3.634,2.048,5.705,5.689,5.705q41.448.01,82.9,0c3.638,0,5.688-2.074,5.69-5.705q0-9.735,0-19.473c0-3.844-2-5.844-5.84-5.844q-20.623,0-41.248,0m-18.887-2.06c.024-.238.047-.367.047-.5q0-9.478,0-18.957c0-1.234-.518-1.717-1.791-1.72q-5.188-.01-10.377,0c-1.585,0-2,.417-2,2.005q0,9.08,0,18.16v1.01ZM23.242,17.217A7.607,7.607,0,1,0,15.649,9.56a7.669,7.669,0,0,0,7.594,7.657",
    transform: "translate(0 0)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49975",
    "data-name": "Path 49975",
    d: "M57.585,10.83c-8.439.166-15.213,2.8-20.878,8.175a4.712,4.712,0,0,1-2.825,1.542,3.848,3.848,0,0,1-3.828-2.173,3.8,3.8,0,0,1,.864-4.478,33.833,33.833,0,0,1,12.167-8C57.953.465,71.3,3.057,82.99,13.807a3.848,3.848,0,0,1,.991,4.542A3.607,3.607,0,0,1,80.173,20.5a5.444,5.444,0,0,1-2.588-1.307,29.511,29.511,0,0,0-15.7-7.918c-1.634-.272-3.3-.347-4.3-.446",
    transform: "translate(10.072 1.067)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49976",
    "data-name": "Path 49976",
    d: "M55.08,13.491a23.879,23.879,0,0,1,16.487,6.86,3.845,3.845,0,1,1-5.3,5.552c-6.833-6.3-16.281-6.316-23.073-.048-1.828,1.686-4.127,1.717-5.688.075s-1.38-3.954.413-5.67A24.522,24.522,0,0,1,55.08,13.491",
    transform: "translate(12.376 4.58)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49977",
    "data-name": "Path 49977",
    d: "M44.406,32.381a7.611,7.611,0,0,1,15.222-.056,7.611,7.611,0,1,1-15.222.056",
    transform: "translate(15.077 8.406)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49978",
    "data-name": "Path 49978",
    d: "M27.1,65.441q-8.435,0-16.867,0c-2.923,0-4.246-1.344-4.248-4.286,0-3.026-.008-6.053,0-9.081a3.584,3.584,0,0,1,3.914-3.9q17.167-.01,34.334,0a3.565,3.565,0,0,1,3.886,3.925q.012,4.74,0,9.48a3.562,3.562,0,0,1-3.854,3.862c-5.722.02-11.445.007-17.166.007m-.025-15.279q-8.535,0-17.071,0C8.555,50.167,8,50.714,8,52.14q-.016,4.641,0,9.283c.005,1.449.549,2,1.983,2q17.073.008,34.143,0c1.494,0,2-.536,2.005-2.074q.008-4.443,0-8.884c0-1.859-.438-2.307-2.276-2.308q-8.387,0-16.772,0",
    transform: "translate(2.033 16.353)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49979",
    "data-name": "Path 49979",
    d: "M58.474,55.179a4.351,4.351,0,0,1-4.411,4.332,4.384,4.384,0,1,1,.1-8.767,4.355,4.355,0,0,1,4.309,4.435",
    transform: "translate(16.884 17.229)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49980",
    "data-name": "Path 49980",
    d: "M61.3,55.155a4.367,4.367,0,0,1,4.339-4.41,4.384,4.384,0,1,1,.051,8.767,4.363,4.363,0,0,1-4.39-4.358",
    transform: "translate(20.812 17.229)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49981",
    "data-name": "Path 49981",
    d: "M14.676,51.166a4.612,4.612,0,1,1-4.631,4.619,4.626,4.626,0,0,1,4.631-4.619m1.015,6.955a2.521,2.521,0,0,0,1.494-3.082,2.6,2.6,0,0,0-5.055.249,2.388,2.388,0,0,0,1.55,2.782c0-.441,0-.824,0-1.206,0-1.309.308-1.882,1.03-1.8,1.081.125.977.985.982,1.751,0,.391,0,.782,0,1.3",
    transform: "translate(3.411 17.372)",
    fill: "#005cbe"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessPoint);
export default __webpack_public_path__ + "static/media/access-point.197015c4dd6955b8371b317684713b31.svg";
export { ForwardRef as ReactComponent };